import { Delete, Edit } from "@mui/icons-material";
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
} from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import { PopupModal } from "../../Components/Modal/Modals";
import {
    TableCellStyle,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import EditState from "./EditState";

const StateVendorShow = ({ states }) => {
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    //edit row
    const [edit, setEdit] = useState(false);
    const handelOpenEditRow = (data) => {
        setData(data);
        setEdit(true);
    };
    const handelCloseEditRow = () => {
        setData({});
        setEdit(false);
    };
    return (
        <>
            <TableRowStyled>
                <TableCellStyle colSpan="3">
                    <Table>
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Address</TableCell>
                            </TableRow>
                        </TableHeadStyled>
                        <TableBody>
                            {states.map((state, index) => (
                                <TableRowStyled key={state.id}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>
                                        {state.email}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {state.phone}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {state.state.name}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {state.address}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        <IconButton onClick={(e) => handelOpenEditRow(state)}>
                                            <Edit color="success" />
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>
                </TableCellStyle>
                {/* EDIT MODAL  */}
                <PopupModal open={edit} close={handelCloseEditRow}>
                    <EditState data={data} />
                </PopupModal>
            </TableRowStyled>
        </>
    );
};

export default StateVendorShow;
